import shouldForwardProp from '@styled-system/should-forward-prop'
import styled from '@emotion/styled'

import {
  PositionContainerProps,
  positionContainerStyles,
} from 'src/components/Box'

export interface Props extends PositionContainerProps {
  url: string
}

const BackgroundImage = styled('div', {
  shouldForwardProp,
})<Props>(positionContainerStyles, ({url}) => ({
  backgroundImage: `url(${url})`,
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'contain',
}))

export default BackgroundImage
